module.exports = __webpack_public_path__ + "static/img/place-main-img.e3dab244.png";